export default "__VITE_ASSET__C$6r_tgZ__"